import { SxProps } from '@mui/material';

export const CardLinkFrameSx: SxProps = {
	border: '1px solid #C9C9C9',
	height: '120px',
	minWidth: '170px',
	maxWidth: '170px',
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
	justifyContent: 'center',
	alignItems: 'center',
	borderRadius: 1.5,
	'&:hover': {
		backgroundColor: '#F0F7FF',
		border: '2px solid #2682E7',
		'& svg': {
			fill: '#2682E7',
		},
		'#shipping-deliveries-svg': {
			stroke: '#2682E7',
		},
		'#returns-svg': {
			stroke: '#2682E7',
		},
		'& p': {
			color: '#2682E7',
		},
	},
	'&:active': {
		backgroundColor: '#F0F7FF',
		border: '2px solid #2682E7',
		'& svg': {
			fill: '#2682E7',
		},
		'#shipping-deliveries-svg': {
			stroke: '#2682E7',
		},
		'#returns-svg': {
			stroke: '#2682E7',
		},
		'& p': {
			color: '#2682E7',
		},
	},
};

export const CardLinkNameSx: SxProps = {
	color: '#2C2C2C',
	fontSize: 'var(--font-size-default)',
	fontWeight: '600',
	textTransform: 'uppercase',
};
